
import Banner1 from '../images/Banner_1.jpg';
import Banner2 from '../images/Banner_2.jpg';
import Banner3 from '../images/Banner_3.jpg';
import Banner4 from '../images/Banner_4.jpg';
import Banner5 from '../images/Banner_5.jpg';

import ComboImage1 from '../images/Combo1.jpg';
import ComboImage2 from '../images/Combo2.jpg';
import ComboImage3 from '../images/Combo3.jpg';

// Import Store Logos/Icons if needed
import Loja1 from '../images/Loja1.png';
import Loja2 from '../images/Loja2.png';
import Loja3 from '../images/Loja3.png';
import Loja4 from '../images/Loja4.png';
import Loja5 from '../images/Loja5.png';
import Loja6 from '../images/Loja6.png';

export const banners = [
  { id: 1, image: Banner1, alt: "Deliciosos Salgados e Doces" },
  { id: 2, image: Banner2, alt: "Festa Completa com O Famoso" },
  { id: 3, image: Banner3, alt: "Qualidade Garantida" },
  { id: 4, image: Banner4, alt: "Variedade de Sabores" },
  { id: 5, image: Banner5, alt: "Peça Já o Seu" }
];

export const locations = [
  {
    id: 1,
    name: "Manoel de Vasconcelos",
    city: "Sumaré",
    address: "Rua Alameda dos Salgueiros, 309",
    phones: ["(19) 99902.0220"],
    mapsLink: "https://www.google.com/maps/@-22.8215271,-47.2559827,3a,75y,10.43h,86.07t/data=!3m7!1e1!3m5!1s2LyrWXNIdtcLk2kbCTxqEA!2e0!6shttps:%2F%2Fstreetviewpixels-pa.googleapis.com%2Fv1%2Fthumbnail%3Fcb_client%3Dmaps_sv.tactile%26w%3D900%26h%3D600%26pitch%3D3.9266449914884305%26panoid%3D2LyrWXNIdtcLk2kbCTxqEA%26yaw%3D10.427762133404563!7i16384!8i8192?entry=ttu&g_ep=EgoyMDI1MTExNi4wIKXMDSoASAFQAw%3D%3D",
    orderLink: "https://vasconcelos.ofamoso.com.br/",
    icon: Loja1
  },
  {
    id: 2,
    name: "Avenida Rebouças",
    city: "Sumaré",
    address: "Av. Rebouças, 3449, Centro",
    phones: ["(19) 3883.7962", "(19) 99742.4698"],
    mapsLink: "https://www.google.com/maps/@-22.8301331,-47.2658971,3a,75y,47.82h,81.59t/data=!3m7!1e1!3m5!1smCt_hKprljyWPUpOdOiw9Q!2e0!6shttps:%2F%2Fstreetviewpixels-pa.googleapis.com%2Fv1%2Fthumbnail%3Fcb_client%3Dmaps_sv.tactile%26w%3D900%26h%3D600%26pitch%3D8.412403392636762%26panoid%3DmCt_hKprljyWPUpOdOiw9Q%26yaw%3D47.81737018051839!7i16384!8i8192?entry=ttu&g_ep=EgoyMDI1MTExNi4wIKXMDSoASAFQAw%3D%3D",
    orderLink: "https://reboucas.ofamoso.com.br/",
    icon: Loja2
  },
  {
    id: 3,
    name: "Matão",
    city: "Sumaré",
    address: "Rua Antônio Francisco Filho, 10",
    phones: ["(19) 2218.0337", "(19) 97156.0020"],
    mapsLink: "https://www.google.com/maps/@-22.834049,-47.1652067,3a,75y,150.09h,82.81t/data=!3m7!1e1!3m5!1sMK3V84ch3JL603mxijL8dw!2e0!6shttps:%2F%2Fstreetviewpixels-pa.googleapis.com%2Fv1%2Fthumbnail%3Fcb_client%3Dmaps_sv.tactile%26w%3D900%26h%3D600%26pitch%3D7.193037749292245%26panoid%3DMK3V84ch3JL603mxijL8dw%26yaw%3D150.08741746446873!7i16384!8i8192?entry=ttu&g_ep=EgoyMDI1MTExNi4wIKXMDSoASAFQAw%3D%3D",
    orderLink: "https://matao.ofamoso.com.br/",
    icon: Loja3
  },
  {
    id: 4,
    name: "Residencial Bordon",
    city: "Sumaré",
    address: "Av. Fuad Assef Maluf, 1432",
    phones: ["(19) 99666.2628", "(19) 99689.1432"],
    mapsLink: "https://www.google.com/maps/@-22.8045716,-47.2679981,3a,75y,21.51h,88.86t/data=!3m7!1e1!3m5!1stp6tkTKCaWw2xkhDyqBU8w!2e0!6shttps:%2F%2Fstreetviewpixels-pa.googleapis.com%2Fv1%2Fthumbnail%3Fcb_client%3Dmaps_sv.tactile%26w%3D900%26h%3D600%26pitch%3D1.143922161663454%26panoid%3Dtp6tkTKCaWw2xkhDyqBU8w%26yaw%3D21.51441816507471!7i16384!8i8192?entry=ttu&g_ep=EgoyMDI1MTExNi4wIKXMDSoASAFQAw%3D%3D",
    orderLink: "https://bordon.ofamoso.com.br/",
    icon: Loja4
  },
  {
    id: 5,
    name: "Lot. Remanso Campineiro",
    city: "Hortolândia",
    address: "Rua Zacharias Costa Camargo, 200",
    phones: ["(19) 99982.1087", "(19) 99804.7320"],
    mapsLink: "https://www.google.com/maps/@-22.8657685,-47.2166458,3a,75y,261.29h,82.19t/data=!3m7!1e1!3m5!1suxpCE_wf3WiW1p2p-CR2RA!2e0!6shttps:%2F%2Fstreetviewpixels-pa.googleapis.com%2Fv1%2Fthumbnail%3Fcb_client%3Dmaps_sv.tactile%26w%3D900%26h%3D600%26pitch%3D7.808895073027273%26panoid%3DuxpCE_wf3WiW1p2p-CR2RA%26yaw%3D261.29050001132134!7i16384!8i8192?entry=ttu&g_ep=EgoyMDI1MTExNi4wIKXMDSoASAFQAw%3D%3D",
    orderLink: "https://hortolandia.ofamoso.com.br/",
    icon: Loja5
  },
  {
    id: 6,
    name: "Jardim Metonópolis",
    city: "Campinas",
    address: "Av. Armando Mário Tozi, 225",
    phones: ["(19) 99703.5138"],
    mapsLink: "https://www.google.com/maps/place/Av.+Armando+Mario+Tozzi,+225+-+Jardim+Meton%C3%B3polis,+Campinas+-+SP,+13058-464/@-22.9519911,-47.1854435,3a,75y,72.58h,90t/data=!3m4!1e1!3m2!1s-bX57LV20ADk08nHSUiqMg!2e0!4m2!3m1!1s0x94c8b712a5bea873:0x1703a062d6bd134a?sa=X&ved=1t:3780&ictx=111",
    orderLink: "https://metonopolis.ofamoso.com.br/",
    icon: Loja6
  }
];

export const combos = [
  {
    id: 1,
    name: "COMBO 1",
    items: [
      "25 salgados",
      "25 churros",
      "1 refrigerante Vannucci (2L)"
    ],
    price: "R$40,00",
    image: ComboImage1
  },
   {
    id: 2,
    name: "COMBO 2",
    items: [
      "50 salgados",
      "25 churros",
      "1 refrigerante Vannucci (2L)"
    ],
    price: "R$50,00",
    image: ComboImage2
  },
   {
    id: 3,
    name: "COMBO 3",
    items: [
      "100 salgados",
      "25 churros",
      "1 refrigerante Vannucci (2L)"
    ],
    price: "R$80,00",
    image: ComboImage3
  }
];
